import styled from '@emotion/styled';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const StyledCollapse = styled(Collapse)`
  background: transparent !important;
  border: none !important;

  .ant-collapse-item {
    border: 1px solid #000 !important;
    margin-bottom: 16px;
    border-radius: 8px !important;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .ant-collapse-header {
    background: #322a2c !important;
    color: #ffffff !important;
    border: none !important;
    padding: 16px 20px !important;
    font-weight: 500;
    font-size: 16px;
    align-items: center;

    .ant-collapse-arrow {
      color: #ffffff !important;
    }

    .ant-collapse-header-text {
      flex: 1;
    }
  }

  .ant-collapse-content {
    background: #483e41 !important;
    border: none !important;

    .ant-collapse-content-box {
      padding: 24px !important;
    }
  }
`;

export function SpCollapse({ items = [], activeKey = 'all', ...props }) {
  return (
    <StyledCollapse {...props} defaultActiveKey={activeKey === 'all' ? items.map((ss) => ss.key) : activeKey}>
      {items.map((ss) => (
        <Panel {...ss} key={ss.key}>
          {ss.children}
        </Panel>
      ))}
    </StyledCollapse>
  );
}
